// extracted by mini-css-extract-plugin
export var modalFooter = "_ts-0";